import React from "react";

import logo from "../assets/swca only logo_white.png";

const Logo: React.FC = () => {
  return <img src={logo} alt="SWCA Logo" height="20px"></img>;
};

export { Logo };